export default __webpack_public_path__ + "static/media/purificationofmitra.e77b5a32.png";